export function Loading({ label }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-10 text-center">
      <div
        className="h-8 w-8 animate-spin rounded-full border-2 border-teal-mint border-t-teal-dark"
        role="status"
        aria-label="Loading"
      />
      {label && <p className="text-sm text-gray2">{label}</p>}
    </div>
  );
}
